<template>
  <div class="register-page">
    <div class="register-container">
      <h2>注册</h2>

      <div class="register-form">
        <div class="form-group">
          <label>邮箱 <span class="required">*</span></label>
          <div class="email-input" :class="{ 'input-error': errors.email }">
            <input
              type="email"
              v-model="email"
              placeholder="请输入邮箱"
              :class="{ 'input-error': errors.email }"
            >
          </div>
          <span class="error-message" v-if="errors.email">{{ errors.email }}</span>
        </div>

        <div class="form-group">
          <label>验证码 <span class="required">*</span></label>
          <div class="code-input-group" :class="{ 'input-error': errors.code }">
            <input
              type="text"
              v-model="code"
              placeholder="请输入验证码"
              maxlength="6"
              :class="{ 'input-error': errors.code }"
            >
            <button
              class="send-code-btn"
              :disabled="isSending || !email"
              @click="handleSendCode"
            >
              {{ isSending ? `${countdown}s 后重发` : '发送验证码' }}
            </button>
          </div>
          <span class="error-message" v-if="errors.code">{{ errors.code }}</span>
        </div>

        <div class="form-group">
          <label>手机号 <span class="required">*</span></label>
          <div class="phone-input" :class="{ 'input-error': errors.phone }">
            <input
              type="text"
              v-model="phone"
              placeholder="请输入手机号"
              maxlength="11"
              :class="{ 'input-error': errors.phone }"
            >
          </div>
          <span class="error-message" v-if="errors.phone">{{ errors.phone }}</span>
        </div>

        <div class="form-group">
          <label>设置密码</label>
          <div class="password-input">
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              placeholder="请设置6-20位密码"
              maxlength="20"
            >
            <button class="toggle-password" @click="showPassword = !showPassword">
              <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
          <span class="error-message" v-if="errors.password">{{ errors.password }}</span>
        </div>

        <div class="form-group">
          <label>确认密码</label>
          <div class="password-input">
            <input
              :type="showConfirmPassword ? 'text' : 'password'"
              v-model="confirmPassword"
              placeholder="请再次输入密码"
              maxlength="20"
            >
            <button class="toggle-password" @click="showConfirmPassword = !showConfirmPassword">
              <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
          <span class="error-message" v-if="errors.confirmPassword">{{ errors.confirmPassword }}</span>
        </div>

        <div class="agreement-check">
          <label class="checkbox-label">
            <input type="checkbox" v-model="agreeTerms">
            <span class="checkmark"></span>
            <span class="text">我已阅读并同意</span>
          </label>
          <div class="agreement-links">
            <router-link to="/terms">服务条款</router-link>
            <span>和</span>
            <router-link to="/privacy">隐私政策</router-link>
          </div>
        </div>
        <span class="error-message" v-if="errors.agreement">{{ errors.agreement }}</span>

        <button class="register-btn" @click="handleRegister">注册</button>

        <div class="login-link">
          已有账号？<router-link to="/login">立即登录</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/utils/request'

export default {
  name: 'RegisterView',
  data() {
    return {
      email: '',
      code: '',
      phone: '',
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      agreeTerms: false,
      isSending: false,
      countdown: 60,
      timer: null,
      errors: {
        email: '',
        code: '',
        phone: '',
        password: '',
        confirmPassword: '',
        agreement: ''
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    async handleSendCode() {
      if (!this.email) {
        this.errors.email = '请输入邮箱'
        return
      }
      if (!this.validateEmail(this.email)) {
        this.errors.email = '请输入正确的邮箱格式'
        return
      }
      this.errors.email = ''

      try {
        const data = await request('/api/auth/email/sendCode', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email: this.email, type: 1 })
        })

        if (data.ok) {
          this.$message.success('验证码已发送，请查收邮箱')
          this.startCountdown()
        } else {
          this.$message.error(data.msg || '发送验证码失败')
        }
      } catch (error) {
        console.error('发送验证码失败:', error)
        this.$message.error('发送验证码失败，请稍后重试')
      }
    },
    startCountdown() {
      this.isSending = true
      this.countdown = 60
      this.timer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--
        } else {
          this.stopCountdown()
        }
      }, 1000)
    },
    stopCountdown() {
      this.isSending = false
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    validateForm() {
      let isValid = true
      this.errors = {
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        agreement: ''
      }

      if (!this.email) {
        this.errors.email = '请输入邮箱'
        isValid = false
      } else if (!this.validateEmail(this.email)) {
        this.errors.email = '请输入正确的邮箱格式'
        isValid = false
      }

      if (!this.code) {
        this.errors.code = '请输入验证码'
        isValid = false
      } else if (this.code.length !== 6) {
        this.errors.code = '验证码格式不正确'
        isValid = false
      }

      if (!this.phone) {
        this.errors.phone = '请输入手机号'
        isValid = false
      } else if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.errors.phone = '请输入正确的手机号'
        isValid = false
      }

      if (this.password.length < 6 || this.password.length > 20) {
        this.errors.password = '密码长度需在6-20位之间'
        isValid = false
      }

      if (this.password !== this.confirmPassword) {
        this.errors.confirmPassword = '两次输入的密码不一致'
        isValid = false
      }

      if (!this.agreeTerms) {
        this.errors.agreement = '请阅读并同意服务条款和隐私政策'
        isValid = false
      }

      return isValid
    },
    async handleRegister() {
      if (!this.validateForm()) {
        this.$message.warning('请检查输入信息是否正确')
        return
      }
      try {
        // TODO: 调用注册接口
        const response = await fetch('/api/auth/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: this.email,
            phone: this.phone,
            password: this.password,
            code: this.code,
          })
        })
        const data = await response.json()
        if (data.ok) {
          this.$message.success('注册成功')
          this.$router.push('/login')
        } else {
          this.$message.error(data.msg || '注册失败')
        }
      } catch (error) {
        console.error('注册失败:', error)
        this.$message.error('注册失败，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px;
}

.register-container {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 400px;
}

.register-container h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  font-weight: 600;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.form-group label .required {
  color: #f44336;
  margin-left: 4px;
}

.phone-input,
.password-input,
.email-input,
.code-input-group {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  transition: border-color 0.3s ease;
}

.phone-input.input-error,
.password-input.input-error,
.email-input.input-error,
.code-input-group.input-error {
  border-color: #f56c6c;
}

.phone-input.input-error input,
.password-input.input-error input,
.email-input.input-error input,
.code-input-group.input-error input {
  background-color: rgba(245, 108, 108, 0.05);
}

.phone-input input,
.password-input input,
.email-input input,
.code-input-group input {
  flex: 1;
  padding: 12px;
  border: none;
  outline: none;
  font-size: 14px;
  transition: all 0.3s ease;
}

.phone-input input.input-error,
.password-input input.input-error,
.email-input input.input-error,
.code-input-group input.input-error {
  color: #f56c6c;
}

.send-code-btn {
  padding: 0 15px;
  border: none;
  background: #f0f0f0;
  color: #666;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.3s;
  white-space: nowrap;
  border-left: 1px solid #ddd;
}

.send-code-btn:hover:not(:disabled) {
  background: #e0e0e0;
  color: #333;
}

.send-code-btn:disabled {
  cursor: not-allowed;
  color: #999;
}

.toggle-password {
  padding: 0 15px;
  border: none;
  background: none;
  cursor: pointer;
  color: #666;
}

.error-message {
  display: block;
  margin-top: 6px;
  color: #f44336;
  font-size: 12px;
}

.agreement-check {
  margin: 20px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  margin-right: 8px;
}

.agreement-links a {
  color: #4CAF50;
  text-decoration: none;
}

.register-btn {
  width: 100%;
  padding: 12px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.register-btn:hover {
  background: #43A047;
}

.login-link {
  margin-top: 20px;
  text-align: center;
  color: #666;
}

.login-link a {
  color: #4CAF50;
  text-decoration: none;
}
</style>
